<template>
  <div class="row wrapper border-bottom white-bg page-heading mb-2">
    <div class="d-flex align-self-center justify-content-between">
      <h2 class="mt-0">{{ $t("navigations.ract tool") }}</h2>
    </div>
  </div>
  <!-- Main Content -->
  <div class="ibox-content">
    <div class="mb-2">
      <div class="form-group row mb-1">
        <div class="d-flex flex-column flex-lg-row justify-content-lg-start my-2 my-lg-0">

          <div class="col-12 col-md-4 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.phase") }}</label>
              <select class="form-select my-lg-0" v-model="phase">
                <option value="">{{ $t("navigations.all") }}</option>
                <option v-for="(item, index) in phases" :key="index" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4 my-1 my-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.category") }}</label>
              <select v-model="category" class="form-select my-lg-0">
                <option value="">{{ $t("navigations.all") }}</option>
                <option v-for="(item, index) in categoryList" :key="index" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-2 my-1 my-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.site id") }}</label>
              <select v-model="selectedSiteId" class="form-select my-lg-0">
                <option value="">{{ $t("navigations.all") }}</option>
                <option
                  v-for="site in sites"
                  :key="site.siteID"
                  :value="site.siteID"
                >
                {{ site.siteCode }}
              </option>
              </select>
            </div>
          </div>

          <span
            type="button"
            class="col-12 col-lg-2 col-md-2 save_btn w-100 align-self-end"
            @click.prevent="SearchRACT()"
          >
            {{ $t("navigations.search") }}
          </span>
        </div>
      </div>
    </div>
    <div class="ibox-content data-grid-container">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex align-items-center">
          <h6 class="mb-0">{{ $t("navigations.overall risk level") }}&nbsp;</h6>
          <span
            class="status-badge"
            :class="{
              'risk-low': computedRiskLevel === 'Low',
              'risk-medium': computedRiskLevel === 'Medium',
              'risk-high': computedRiskLevel === 'High',
            }"
          >
            Total Risk Score: {{ totalRiskScoreSum }} &nbsp; | &nbsp; {{ computedRiskLevel }}
          </span>
        </div>
        <div class="d-flex align-items-md-start align-items-center">
          <span class="me-1"> RACT version: 2.0 </span> 
          <span class="mr-3"> [13-Mar-2015]</span>
          <div
            class="position-relative cursor-pointer"
            v-if="ractlist.length != 0"
            @click.prevent="showFilter = !showFilter"
          >
            <img
              src="../../assets/img/filter.png"
              width="17"
              height="17"
              alt="filter table"
            />
            <div class="tool-tip">{{ $t("navigations.filter") }}</div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
        <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
          <div
            class="table-multi-select-dropdown"
            @click.stop="dropdownOpen = !dropdownOpen"
          >
            <div class="selected-options">
              <span>{{ $t("navigations.select columns") }}</span>
            </div>
            <div class="dropdown-arrow"></div>
          </div>
          <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
            <label v-for="(column, index) in getColumns" :key="index">
              <input type="checkbox" v-model="selectedcolumnobj[column]" :value="true" />
              {{ column }}
            </label>
          </div>
        </div>
      </div>
      <template v-if="showTableLoader == true">
        <div class="text-center">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="table-responsive custom-dark-table-wrapper table-scroll">
          <table class="table table-striped dark-table-head mb-0 fixed-column-table">
            <thead>
              <tr>
                <th v-if="selectedcolumnobj['Category ID']">{{ $t("navigations.category id") }} </th>
                <th v-if="selectedcolumnobj['Category']"> {{ $t("navigations.category") }}</th>
                <th v-if="selectedcolumnobj['Sub Category']">{{ $t("navigations.subcategory") }} </th>
                <th v-if="selectedcolumnobj['Data Scope']">{{ $t("navigations.datascope") }} </th>
                <th v-if="selectedcolumnobj['Risk Indicator']"> {{ $t("navigations.risk indicator") }}</th>
                <th v-if="selectedcolumnobj['Execution Type']">{{ $t("navigations.execution type") }}</th>
                <th v-if="selectedcolumnobj['Derived Value']"> {{ $t("navigations.derived value") }}</th> 
                <th v-if="selectedcolumnobj['Unit']"> {{ $t("navigations.unit unitname") }}</th> 
                <th v-if="selectedcolumnobj['Probability']">{{ $t("navigations.probability") }} </th>
                <th v-if="selectedcolumnobj['Impact']">{{ $t("navigations.impact") }}</th>
                <th v-if="selectedcolumnobj['Detectability']">{{ $t("navigations.detectability") }}</th>
                <th v-if="selectedcolumnobj['Risk Score']"> {{ $t("navigations.risk score") }}</th>

                <!-- optional columns  intially hidden-->
                <th v-if="selectedcolumnobj['Objectives']"> {{ $t("navigations.objectives") }} </th>
                <th v-if="selectedcolumnobj['discussion Details']"> {{ $t("navigations.discussion details") }}</th>
                <th v-if="selectedcolumnobj['Core']">{{ $t("navigations.core or extendetKRI") }}</th>
                <th v-if="selectedcolumnobj['Level of Scrutiny']">{{ $t("navigations.level of scrutiny") }}</th>
                <th v-if="selectedcolumnobj['Frequency']">{{ $t("navigations.frequency") }}</th>
                <th v-if="selectedcolumnobj['Threshold Basis']">{{ $t("navigations.threshold basis") }}</th>
                <th v-if="selectedcolumnobj['Score Card']">{{ $t("navigations.scorecard inclusion") }}</th>
                <th v-if="selectedcolumnobj['Weighting']">{{ $t("navigations.weighting") }}</th>
                <th v-if="selectedcolumnobj['Mitigation Action']">{{ $t("navigations.mitigation actions") }}</th> 
                <th v-if="selectedcolumnobj['Risk Rating']">{{ $t("navigations.risk rating") }}</th>
                <th v-if="selectedcolumnobj['Phase']">{{ $t("navigations.phase") }}</th>
                <th v-if="selectedcolumnobj['Execution Date']"> {{ $t("navigations.execution date") }} </th>
                <th v-if="selectedcolumnobj['Type of Risk']"> {{ $t("navigations.type of risk") }} </th>

                <th>{{ $t("navigations.threshold") }}</th>
                <th>{{ $t("navigations.manual score") }}</th>
              </tr>
            </thead>
            <tbody class="custom-table-wrapper">

              <tr v-for="item in ractlist" :key="item.id"> 
                <td v-if="selectedcolumnobj['Category ID']" class="text-center py-0"> {{ item.categoryId }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Category']">{{ item.category }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Sub Category']">
                  <div>
                    <span v-if="!showMoreCategory[item.id]">
                      {{ item.subCategory ? item.subCategory.substring(0, 30) : "" }}
                      <span
                        class="cursor-pointer more-block"
                        v-if="item.subCategory && item.subCategory.length > 30"
                        @click="showMoreCategory[item.id] = true"
                        >...More</span
                      >
                    </span>
                    <span class="breakWord" v-else>
                      {{ item.subCategory }}
                      <span
                        class="cursor-pointer more-block"
                        @click="showMoreCategory[item.id] = false"
                        >Show Less</span
                      >
                    </span>
                  </div>
                </td>
                <td class="py-1" v-if="selectedcolumnobj['Data Scope']"> {{ item.dataScope }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Risk Indicator']"> {{ item.riskIndicator }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Execution Type']"> {{ item.executionType }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Derived Value']">{{ item.value }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Unit']">{{ item.unit }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Probability']">
                  <div v-if="editedRowId === item.id">
                    <select
                      v-model="editableRow.probability"
                      @change="updateScore"
                      class="form-select w-auto risk-level-select"
                      :class="{
                        'risk-low': editableRow.probability === 'Low',
                        'risk-medium': editableRow.probability === 'Medium',
                        'risk-high': editableRow.probability === 'High',
                      }"
                    >
                      <option :value="'High'">High (3)</option>
                      <option :value="'Medium'">Medium (2)</option>
                      <option :value="'Low'">Low (1)</option>
                    </select>
                  </div>
                  <div class="text-center" v-else>
                    {{ item.probabilityPoint }}
                  </div>
                </td>
                <td class="py-1" v-if="selectedcolumnobj['Impact']">
                  <div v-if="editedRowId === item.id">
                    <select
                      v-model="editableRow.impact"
                      @change="updateScore"
                      class="form-select w-auto risk-level-select"
                      :class="{
                        'risk-low': editableRow.impact === 'Low',
                        'risk-medium': editableRow.impact === 'Medium',
                        'risk-high': editableRow.impact === 'High',
                      }"
                    >
                      <option :value="'High'">High (3)</option>
                      <option :value="'Medium'">Medium (2)</option>
                      <option :value="'Low'">Low (1)</option>
                    </select>
                  </div>
                  <div class="text-center" v-else>
                    {{ item.impactPoint }}
                  </div>
                </td>
                <td class="py-1" v-if="selectedcolumnobj['Detectability']">
                  <div v-if="editedRowId === item.id">
                    <select
                      v-model="editableRow.detectability"
                      @change="updateScore"
                      class="form-select w-auto risk-level-select"
                      :class="{
                        'risk-low': editableRow.detectability === 'Easy to detect',
                        'risk-medium': editableRow.detectability === 'Medium to detect',
                        'risk-high': editableRow.detectability === 'Difficult to detect',
                      }"
                    >
                      <option :value="'Difficult to detect'">Difficult  (3) </option>
                      <option :value="'Medium to detect'">Medium (2)</option>
                      <option :value="'Easy to detect'">Easy (1)</option>
                    </select>
                  </div>
                  <div class="text-center" v-else>
                    {{ item.detectabilityPoint }}
                  </div>
                </td>
                <td v-if="selectedcolumnobj['Risk Score']" class = "py-1 text-center">
                  <div v-if="editedRowId === item.id">
                    {{ editableRow.totalCategoryRiskScore }}
                  </div>
                  <div v-else>
                    <span
                      class="status-badge"
                      :style="{ backgroundColor: item && item.riskLevelColor ? item.riskLevelColor : '#87d37c' }"

                    >
                      {{ item.totalCategoryRiskScore }}
                    </span>
                  </div>
                </td>

                <!-- optional columns  intially hidden-->
                <td class="py-1" v-if="selectedcolumnobj['Objectives']"> {{ item.objectives }}</td>
                <td class="py-1 align-top" v-if="selectedcolumnobj['Discussion Details']">
                  <div>
                    <span v-if="!showMoreDescription[item.id]">
                      {{
                        item.discussionDetails
                          ? item.discussionDetails.substring(0, 30)
                          : ""
                      }}
                      <span
                        class="cursor-pointer more-block"
                        v-if="
                          item.discussionDetails && item.discussionDetails.length > 30
                        "
                        @click="showMoreDescription[item.id] = true"
                        >...More</span
                      >
                    </span>
                    <span class="breakWord" v-else>
                      {{ item.discussionDetails }}
                      <span
                        class="cursor-pointer more-block"
                        @click="showMoreDescription[item.id] = false"
                        >Show Less</span
                      >
                    </span>
                  </div>
                </td>
                <td class="py-1" v-if="selectedcolumnobj['Core']">{{ item.coreOrExtendedKRI }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Level of Scrutiny']"> {{ item.levelOfScrutiny }} </td>
                <td class="py-1" v-if="selectedcolumnobj['Frequency']">{{ item.frequency }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Threshold Basis']">{{ item.thresholdBasis }}</td>
                <td class="text-center py-1" v-if="selectedcolumnobj['Score Card']">{{ item.score }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Weighting']">{{ item.weighting }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Mitigation Action']">{{ item.mitigationActions }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Risk Rating']">{{ item.riskLevelLabel }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Phase']">{{ item.phase }}</td>
                <td class="py-1" v-if="selectedcolumnobj['Execution Date']">{{ filter(item.CreatedAt) }}</td>
                <td class="text-center py-1" v-if="selectedcolumnobj['Type of Risk']">{{ item.typeOfRisk }}</td>

                <!-- Actions -->
                <td class="text-center py-1">
                    <button class="btn text-primary p-0 me-1" @click="openCriticalDP(item)">
                      <i class="fa fa-sliders"></i>
                    </button>
                </td>
                <td  v-if="this.ractlist.length > 0" class=" text-center py-1">
                  <div v-if="editedRowId === item.id" class="d-flex justify-content-center gap-1">
                    <button class="btn text-success p-0 me-1" title="Save" @click="CreateRiskScore(item)">
                      <i class="fa fa-save"></i>
                    </button>
                    <button class="btn text-secondary p-0" title="Close" @click="cancelEdit">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div v-else>
                    <button class="btn text-primary p-0 me-1"  @click="startEdit(item)">
                      <i class="fa fa-edit"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
  <ThresholdPopup
    v-if="showThresholdPopup"
    :studyId="studyId"
    :riskId="selectedRiskId"
    :version="selectedVersion"
    @closeThresholdModal="closeCriticalDataPopup"
  />
  <CriticalDPModal
        v-if="showCriticalPopUp"
        :criticalInfo="criticalDataPoints[0]"
        formPage="ThresholdPopup"
        @closeModal="closeCriticalDataPopup"
   />

</template>

<script src="./RactTool.js"></script> 

<style scoped>
.more-block {
  color: blue;
  cursor: pointer;
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
:root {
  --primary: #1a6aa2;
  --secondary: #28a745;
  --light-bg: #f8f9fa;
  --card-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  --border-radius: 10px;
  --success-bg: #d4edda;
  --success-border: #c3e6cb;
}

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}

.status-badge {
  padding: 0.1rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
}

.risk-low {
  background: #d4edda;
  color: #155724;
}

.risk-medium {
  background: #fff3cd;
  color: #856404;
}

.risk-high {
  background: #f8d7da;
  color: #721c24;
}

.breakWord {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}

.table-scroll {
  max-height: 60vh;
  overflow: auto;
}

.fixed-column-table {
  --last-col-width: 98px;
  --second-last-col-width: 80px;
  width: max-content;
  min-width: 100%;
}

.fixed-column-table th,
.fixed-column-table td {
  padding: 8px 12px;
  white-space: nowrap;
  background: #fff;
}

.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  width: var(--last-col-width);
  min-width: var(--last-col-width);
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  width: var(--second-last-col-width);
  min-width: var(--second-last-col-width);
}

.fixed-column-table thead th {
  position: sticky;
  top: 0;
  z-index: 0;
  background: #1a6aa2;
  color: #fff;
}
.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  position: sticky;
  right: 0;
  z-index: 0;
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  position: sticky;
  right: var(--last-col-width);
  z-index: 0;
}

.fixed-column-table thead th:last-child,
.fixed-column-table thead th:nth-last-child(2) {
  z-index: 1;
}
</style>